import { useLayout } from 'context'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import * as controllers from 'controllers'
import { ArrowBack } from '@mui/icons-material'
import { Grid, Card, CardContent, Typography, Button } from '@mui/material'
import { VehicleNeedsClusterConversionInHouseDetailsDto } from 'dtos'
import { enqueueSnackbar } from 'notistack'
import VehicleNeedsClusterConversionInHouseHeroCard from './VehicleNeedsClusterConversionInHouseHeroCard'
import Step1StartClusterConversion from './Step1StartClusterConversion'

export default function NeedsClusterConversionInHouse() {
  const { vehicleGuid } = useParams()
  const layout = useLayout()
  const navigate = useNavigate()

  const [initialValues, setInitialValues] = useState<VehicleNeedsClusterConversionInHouseDetailsDto>(
    new VehicleNeedsClusterConversionInHouseDetailsDto()
  )

  const [activeStep] = useState<number>(0)

  useEffect(() => {
    if (vehicleGuid) {
      layout.setIsLayoutLoading(true)
      controllers
        .getNeedsClusterConversionInHouseDetails(vehicleGuid)
        .then(response => {
          setInitialValues(response.value)
        })
        .finally(() => {
          layout.setIsLayoutLoading(false)
        })
    }
  }, [vehicleGuid])

  const isConversionStarted = Boolean(initialValues?.clusterConversionInHouseStarted)
  const successMessage = isConversionStarted
    ? 'Cluster Conversion In-House Completed Successfully!'
    : 'Cluster Conversion In-House Started Successfully!'

  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid container justifyContent='space-between'>
              <Grid item>
                <Typography fontWeight='bold' variant='h5' sx={{ pr: 1 }}>
                  Needs Cluster Conversion In-House
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto' container spacing={2} alignItems='center' justifyContent='flex-end'>
                <Grid item>
                  <Button
                    onClick={() => {
                      navigate('/to-do-list')
                    }}
                    color='primary'
                    startIcon={<ArrowBack />}
                    variant='text'
                  >
                    BACK
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <VehicleNeedsClusterConversionInHouseHeroCard vehicle={initialValues} />
      </Grid>

      {activeStep === 0 && (
        <Grid item xs={12}>
          <Step1StartClusterConversion
            needsClusterConversionInHouseDetails={initialValues}
            onNext={() => {
              layout.setIsLayoutLoading(true)
              controllers
                .updateNeedsClusterConversionInHouseDetails(vehicleGuid!, {
                  ...initialValues
                })
                .then(response => {
                  enqueueSnackbar(successMessage, { variant: 'success' })
                  setInitialValues(response.value)
                  navigate('/to-do-list', { replace: true })
                })
                .finally(() => {
                  layout.setIsLayoutLoading(false)
                })
            }}
            vehicle={initialValues}
            vehicleGuid={vehicleGuid}
          />
        </Grid>
      )}
    </Grid>
  )
}
